<template>
	<section
		class="hero section pb-0"
		:class="[
			topOuterDivider && 'has-top-divider',
			bottomOuterDivider && 'has-bottom-divider',
			hasBgColor && 'has-bg-color',
			invertColor && 'invert-color',
		]"
	>
		<div class="container">
			<div
				class="hero-inner section-inner"
				:class="[
					topDivider && 'has-top-divider',
					bottomDivider && 'has-bottom-divider',
				]"
                style="padding-bottom: 2rem;"
			>
				<div
					class="split-wrap"
					:class="[
						invertMobile && 'invert-mobile',
						invertDesktop && 'invert-desktop',
						alignTop && 'align-top',
					]"
				>
					<div class="split-item">
						<div class="hero-content split-item-content center-content-mobile">
							<h1 class="mt-0 mb-16 reveal-fade" data-reveal-delay="150">
								Sell products directly to developers
							</h1>
							<p class="mt-0 mb-32 reveal-fade" data-reveal-delay="300">
								Discover new prospects with rich data on millions of developers
								and start landing your ideal customers faster than ever.
							</p>
							<div class="reveal-fade" data-reveal-delay="450">
                                <c-button tag="a" wide-mobile color="dark" @click="showDataModal" class="mr-12 mb-12">
									<div style="display: flex;"><span style="font-family: 'Material Icons'; font-size: 14px" class="mr-12">table_chart</span><span>View sample</span></div>
								</c-button>
								<c-button tag="a" wide-mobile  color="primary" href="/signup"  class="mr-12 mb-12">
									<div style="display: flex;"><span>Get started</span><span style="font-family: 'Material Icons';" class="ml-12">chevron_right</span></div>
								</c-button>
                                </div>
							</div>
						</div>
					</div>
				</div>
			</div>
            <modal name="sample" :adaptive="false" :scrollable="true" transition="bounce" width="75%" height="75%" styles="overflow-x:scroll; background-color: #2B2B52; border-radius: 20px; padding: 20px; position: relative;
                box-sizing: border-box;
                margin: 0;
                padding: 0;">
                <div style=" border-radius: 20px; padding-top: 20px; padding-right: 20px; padding-left: 20px; position: sticky; top: 0px; left: 0px; background: rgb(43, 43, 82);">
                    <c-image
                        :src="require('@/assets/images/github.png')"
                        :width="48"
                        :height="48"
                        class="pb-12"
                        style="display:inline"
                    />
                    <span class="text-md" style="font-family: monospace; color:white">
                        <b>
                            hooli/box3
                        </b>
                    </span>
                </div>
                <table-component
                    :min-rows="100000000"
                    :data='[{
                        "username": "dnetting0",
                        "first_name": "Dorey",
                        "last_name": "Netting",
                        "email": "dnetting0@who.int",
                        "fork": true,
                        "watcher": false,
                        "contributor": true,
                        "language": "Javascript",
                        "time_zone": "Asia/Manila",
                        "last_commit": "08/22/2018"
                        }, {
                        "username": "wdominick1",
                        "first_name": "Wiatt",
                        "last_name": "Dominick",
                        "email": "wdominick1@quantcast.com",
                        "fork": false,
                        "watcher": true,
                        "contributor": false,
                        "language": "Ruby",
                        "time_zone": "Europe/Lisbon",
                        "last_commit": "06/07/2019"
                        }, {
                        "username": "eyerborn2",
                        "first_name": "Esra",
                        "last_name": "Yerborn",
                        "email": "eyerborn2@g.co",
                        "fork": true,
                        "watcher": true,
                        "contributor": false,
                        "language": "Go",
                        "time_zone": "Asia/Harbin",
                        "last_commit": "01/26/2021"
                        }, {
                        "username": "mosbiston3",
                        "first_name": "Mohammed",
                        "last_name": "Osbiston",
                        "email": "mosbiston3@mysql.com",
                        "fork": true,
                        "watcher": true,
                        "contributor": false,
                        "language": "Objective-C",
                        "time_zone": "Europe/Ljubljana",
                        "last_commit": "12/15/2019"
                        }, {
                        "username": "frubinsaft4",
                        "first_name": "Farica",
                        "last_name": "Rubinsaft",
                        "email": "frubinsaft4@privacy.gov.au",
                        "fork": false,
                        "watcher": false,
                        "contributor": true,
                        "language": "SQL",
                        "time_zone": "Europe/Paris",
                        "last_commit": "03/03/2019"
                        }, {
                        "username": "ebiagi5",
                        "first_name": "Eddie",
                        "last_name": "Biagi",
                        "email": "ebiagi5@foxnews.com",
                        "fork": true,
                        "watcher": true,
                        "contributor": true,
                        "language": "Ruby",
                        "time_zone": "Asia/Bangkok",
                        "last_commit": "09/04/2018"
                        }, {
                        "username": "bdixon6",
                        "first_name": "Berty",
                        "last_name": "Dixon",
                        "email": "bdixon6@hibu.com",
                        "fork": false,
                        "watcher": false,
                        "contributor": true,
                        "language": "Python",
                        "time_zone": "Asia/Tokyo",
                        "last_commit": "07/05/2020"
                        }, {
                        "username": "spannett7",
                        "first_name": "Sammie",
                        "last_name": "Pannett",
                        "email": "spannett7@liveinternet.ru",
                        "fork": false,
                        "watcher": true,
                        "contributor": true,
                        "language": "Objective-C",
                        "time_zone": "Asia/Makassar",
                        "last_commit": "06/10/2018"
                        }, {
                        "username": "tsauntf",
                        "first_name": "Taber",
                        "last_name": "Saunt",
                        "email": "tsauntf@arizona.edu",
                        "fork": false,
                        "watcher": false,
                        "contributor": false,
                        "language": "SQL",
                        "time_zone": "Europe/Belgrade",
                        "last_commit": "08/12/2019"
                        }, {
                        "username": "ctregienh",
                        "first_name": "Charmion",
                        "last_name": "Tregien",
                        "email": "ctregienh@amazon.de",
                        "fork": true,
                        "watcher": true,
                        "contributor": true,
                        "language": "Go",
                        "time_zone": "Asia/Jakarta",
                        "last_commit": "12/17/2017"
                        }, {
                        "username": "sbanghei",
                        "first_name": "Sascha",
                        "last_name": "Banghe",
                        "email": "sbanghei@paginegialle.it",
                        "fork": false,
                        "watcher": false,
                        "contributor": false,
                        "language": "HTML",
                        "time_zone": "Europe/Zurich",
                        "last_commit": "03/03/2017"
                        }]'
                >
                    <table-column show="username" label="Username"></table-column>
                    <table-column show="first_name" label="First Name"></table-column>
                    <table-column show="last_name" label="Last Name"></table-column>
                    <table-column show="email" label="Email"></table-column>
                    <table-column show="fork" label="Fork"></table-column>
                    <table-column show="watcher" label="Watcher" ></table-column>
                    <table-column show="contributor" label="Contributor" ></table-column>
                    <table-column show="language" label="Language"></table-column>
                    <table-column show="time_zone" label="Time Zone"></table-column>
                    <table-column show="last_commit" label="Last Commit" data-type="date:MM/DD/YYYY"></table-column>
                </table-component>
            </modal>
	</section>
</template>

<script>
import { SectionSplitProps } from "@/utils/SectionProps.js";
import CButton from "@/components/elements/Button.vue";
import CImage from "@/components/elements/Image.vue";

export default {
	name: "CHeroSplit",
	components: {
		CButton,
        CImage
	},
	mixins: [SectionSplitProps],
    methods: {
        showDataModal() {
            this.$modal.show('sample')
        }
    }
};
</script>

<style scoped>
@media (min-width: 641px) {
	.split-wrap .split-item {
		align-items: flex-start;
		min-height: 492px;
	}
}
</style>